// LEGACY — superseded by features/tenant-roles/. Scheduled for deletion in 2 sprints.
import { APIClient } from "../helpers/api_helper";
import { getLoggedinUser } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";
import { TenantRoleItem } from "../interfaces/TenantRole";
import { TenantRolesResponse } from "../slices/tenantRoles/types";

const api = new APIClient();

// Check if we should use the fake backend
// Helper function to get tenantId from logged-in user
const getTenantId = (): string | null => {
    const authUser = getLoggedinUser();
    return authUser?.tenantId || null;
};

export const getAllTenantRoles = (
    pageNumber: number = 1,
    pageSize: number = 20,
    tenantId?: string | null
): Promise<TenantRolesResponse> => {
    
    // Get tenantId if not provided
    const finalTenantId = tenantId || getTenantId();
    
    // Real API call with query parameters including tenantId
    const queryParams: any = {
        pageNumber,
        pageSize,
    };
    
    if (finalTenantId) {
        queryParams.tenantId = finalTenantId;
    }
    
    return api.get<TenantRolesResponse>(url.GET_TENANT_ROLES, queryParams);
};

export const getTenantRoleByIdService = (id: string): Promise<TenantRoleItem> => {
    
    return api.get<TenantRoleItem>(url.GET_TENANT_ROLES + "/" + id, {});
};

export const createTenantRoleService = (data: Partial<TenantRoleItem>): Promise<TenantRoleItem> => {
    
    // Get tenantId if not provided in data
    const tenantId = (data as any).tenantId || getTenantId();
    
    if (!tenantId) {
        return Promise.reject(new Error("Organization ID is required"));
    }
    
    // Validate required fields
    if (!data.profileId || data.profileId.trim() === "") {
        return Promise.reject(new Error("Profile ID is required"));
    }
    
    if (!data.name || data.name.trim() === "") {
        return Promise.reject(new Error("Role name is required"));
    }
    
    if (!data.description || data.description.trim() === "") {
        return Promise.reject(new Error("Role description is required"));
    }
    
    // Format payload according to API specification
    const payload = {
        tenantId: tenantId,
        profileId: data.profileId,
        name: data.name.trim(),
        description: data.description.trim(),
        isSensitive: data.isSensitive || false,
    };
    
    // Debug logging
    if (process.env.NODE_ENV === 'development') {
        console.log("🟢 Creating Tenant Role - Payload:", payload);
    }
    
    return api.create<TenantRoleItem>(url.POST_TENANT_ROLE, payload);
};

export const updateTenantRoleService = (
    id: string,
    data: Partial<TenantRoleItem>
): Promise<TenantRoleItem> => {
    
    // Get tenantId if not provided in data
    const tenantId = (data as any).tenantId || getTenantId();
    
    if (!tenantId) {
        return Promise.reject(new Error("Organization ID is required"));
    }
    
    // Format payload according to API specification
    const payload = {
        tenantId: tenantId,
        profileId: data.profileId,
        name: data.name,
        description: data.description,
        isSensitive: data.isSensitive || false,
    };
    
    return api.put<TenantRoleItem>(url.PUT_TENANT_ROLE + "/" + id, payload);
};

export const deleteTenantRoleService = (id: string): Promise<void> => {
    
    return api.delete<void>(url.DELETE_TENANT_ROLE + "/" + id);
};

